import React from 'react'

function ErrorPage() {
  return (
    <div className='flex items-center justify-center w-full h-full'>ErrorPage</div>
  )
}

export default ErrorPage